module.exports = __webpack_public_path__ + "static/media/Sachin Ji-Model.61872a6e.pdf";